import { NgModule } from '@angular/core';

import { FormatContactInfoPipe } from './format-contact-info';

@NgModule({
  declarations: [FormatContactInfoPipe],
  exports: [FormatContactInfoPipe]
})
export class FormatContactInfoPipeModule { }
